/**
 * @Author: zpc
 * @DateTime: Created in 2021-08-12 14:00:00
 * @Description: 数据自动对接接口层
 */

import Api from "src/util/api";
import {PageDo, Result, ResultPageDo, Integer} from "src/types/base";
import { defaultNullValue } from 'src/config';
import { promises } from 'fs';

export declare namespace DataButtJointDOI{
    //返回主列表数据
    export interface RowDataI{
        id: number,
        dispose_site: number,
        is_open: number,  //是否开启数据上传
        is_token: number, //是否需要验证token权限
        post_url: string,  //数据上传url
        name:string,       // 站点名称
        cn:string,
    }
    //单个站点返回所有数据
    export interface QuerySingleALLResultI{
        is_open: number,  //是否开启数据上传
        is_token: number, //是否需要验证token权限
        token_url: string, // 鉴权url
        post_url: string, // 数据上传url
        parameter: string, //数据上传所需因子
        token_user_name: string, // 鉴权账号
        token_password: string,  //鉴权密码
        is_url_parameter: number, // 鉴权是否url传参
        is_header_token: number, // 是否header上传token
        device_id: number,   //站点id
        cn:string, //cn
    }
    //新增修改实体
    export interface AddOrEditParamsI{
        dispose_site: number,  //站点id
        is_open: number, // 是否开启数据上传
        is_token: number, // 是否需要验证token
        token_url?: string, //鉴权url
        token_user_name?: string, //鉴权url账号
        token_password?: string, // 鉴权url密码
        is_url_parameter?:number, //鉴权是否url传参
        is_header_token?: number, // 是否header上传token
        post_url: string, //数据上传url
        parameter: string, // 数据上传所需因子
        id?:number,   //数据id 
        cn:string,    //cn
    }
}

export default class DataButtJoinApi {
    /**
     * 查询主界面列表数据
     * @param params 
     */
    static async searchList(params: PageDo): Promise<ResultPageDo<DataButtJointDOI.RowDataI[]>>{
        return Api.post('/monitor/selete/butt_joint/device', params)
    }

    /**
     * 根据id查询单条数据详情
     * @param id 
     */
    static async searchSingleData(params: { id: number }): promises<Result<DataButtJointDOI.QuerySingleALLResultI[]>>{
        return Api.post('/monitor/selete/butt_joint_device/particulars', params)
    }
    
    /**
     * 新增数据(添加对接站点)
     * @param data 
     */
    static async add(data: DataButtJointDOI.AddOrEditParamsI): promises<Result<any>>{
        return Api.post('/monitor/add/butt_joint/device', data)
    }
    
    /**
     * 编辑数据
     * @param data 
     */
    static async edit(data: DataButtJointDOI.AddOrEditParamsI): promises<Result<any>>{
        return Api.post('/monitor/edit/butt_joint/device', data)
    }
    
    /**
     * 删除数据
     * @param id 
     */
    static async delete(id: number): promises<Result<any>>{
        return Api.post('/monitor/delete/butt_joint/device', id)
    }
}